import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { PackageSummary } from 'frontend/types/lessons/packages';
import { apiResolve } from 'frontend/router';
import { getJson } from 'frontend/utils/ajax';

interface PackageState {
  usablePackages: PackageSummary[];
}

const packages: Module<PackageState, RootState> = {
  namespaced: true,
  state: {
    usablePackages: [],
  },

  mutations: {
    setValue(state: PackageState, value: PackageState) {
      if (value.usablePackages) {
        state.usablePackages = value.usablePackages;
      }
    },
    setUsablePackages(state: PackageState, usablePackages: PackageSummary[]) {
      state.usablePackages = usablePackages;
    },
  },

  actions: {
    async loadUsablePackages({ commit }): Promise<void> {
      const response = await getJson(apiResolve({ name: 'elm_packages_list' }).href);
      commit('setUsablePackages', response.results.packages);
    },
  },
};

export default packages;
